import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';

interface PageBodyProps {
  tokenPrefix?: string;
}

export function PageBody({ tokenPrefix }: PageBodyProps) {
  const prefix = tokenPrefix || 'pagebody';
  const contentPath = `${prefix}.content`;

  return (
    <section className="bg-[rgb(var(--ala-background))] py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-6 md:px-12">
        <RichTextContent
          path={contentPath}
          label="Page content"
          as="div"
          className="font-body text-base leading-relaxed text-[rgb(var(--ala-text))] [&_a]:text-[rgb(var(--ala-secondary))] [&_a]:underline [&_h2]:mb-4 [&_h2]:mt-10 [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:tracking-tight [&_p]:mb-4"
        />
      </div>
      <div className="hidden" style={{ display: 'none' }}>
        <RichTextContent path="pagebody.content" as="div" />
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'PageBody',
  displayName: 'Page Body',
  tokens: {
    'pagebody.content': {
      label: 'Page content',
      type: 'richtext',
      defaultValue:
        '<p>American Landmark Apartments is a Tampa-based multifamily owner-operator creating vibrant communities across the Sunbelt. Edit this section in the Vibesites editor.</p>',
    },
  },
};

(PageBody as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default PageBody;
